import {ShippingRegionDetails} from "./shipping-region-details";

export interface ShippingRegionHeader {
  id: string;
  key: string;
  description: string;
  deliveryProductId: string;
  deliveryProductKey: string;
  deliveryProductDescription: string;
  countryId: string;
  countryCode: string;
  countryName: string;

  shippingRegionDetails: ShippingRegionDetails[];
}
